

/* ⭐⭐ --IMPORTANT-- REQUIRED HTML / CSS ⭐⭐

        👉 HTML:
                <div class="card-list__container"> 
                    <div class="card-list__grid grid__gap_large"> 
                        <!-- Cards Go Here --> 
                        <c-slds-card-flex-height></c-slds-card-flex-height>  ⭐ 3 cards
                        <c-slds-card-flex-height></c-slds-card-flex-height>
                        <c-slds-card-flex-height></c-slds-card-flex-height>
                    </div>
                </div>

        👉 CSS: 
                .card-list__container {
                    container-type: inline-size;
                }
                .card-list__grid {
                    display: grid;
                    grid-template-columns: repeat(3⭐, minmax(0, 1fr));    👈 Set the amount of cards in the grid 
                }
                .grid__gap_large {
                    gap: 1.5rem;
                }
                .feature-set-card {
                    flex-grow: 1;
                    position: relative;
                    overflow-wrap: anywhere;
                }
*/ 

/* Example Usage: 
    <div class="card-list__container"> 
        <div class="card-list__grid grid__gap_large"> 
            <c-slds-card-flex-height
                add-box-shadow="true"
                card-border="solid 1px var(--slds-g-color-border-base-2)"
                card-label="Industry Org Profile"
                card-label-size="18px"
                object-api-name="Account"
                is-footer="true"
            >
*/

const CARD_LABEL_SIZES = {
    'xx-large': 'header-text_xx-large',
    'x-large': 'header-text_x-large',
    large: 'header-text_large',
    medium: 'header-text_medium',
    small: 'header-text_small',
    'x-small': 'header-text_x-small',
    'xx-small': 'header-text_xx-small',
    'xxx-small': 'header-text_xxx-small',
}


import { LightningElement, api } from 'lwc';

import {MATERIAL_ICONS} from '../../../utils/iconMapper.js';

function iconSizeClass(size) {
    if (!size || size === 'medium') {
        return '';
    }

    return `slds-icon_${size}`;
}

function materialIconConfig(iconName, size) {
    const {path = null, viewBox = null} = MATERIAL_ICONS[iconName] || {};
    if (!path || !viewBox) {
        return null;
    }

    return {
        container: 'slds-icon_container slds-line-height_reset slds-current-color',
        svg: `slds-icon ${iconSizeClass(size) || 'slds-icon_small'} slds-m-right_x-small material-icon`,
        path,
        viewBox,
        isMaterialIcon: true
    };
}

function sldsIconConfig(category, iconName, size) {
    const iconNameForClass = iconName?.replaceAll?.('_', '-') || iconName;

    return {
        container: `slds-icon_container slds-icon-${category}-${iconNameForClass}`,
        svg: `slds-icon ${iconSizeClass(size)}`,
        icon: `static/assets/icons/${category}-sprite/svg/symbols.svg#${iconName}`
    };
}

export default class SldsCardFlexHeight extends LightningElement  {
    @api 
    set cardLabel(val) {    
        this._cardLabel = val;
        if (val?.toLowerCase()?.includes('unknown')) {
            this._applyVarsDirect('--c-header-color', 'var(--vg-color-weak, #636363)');
        }
    }
    get cardLabel() {
        return this._cardLabel;
    }
    // xxx-small, xx-small, x-small, small, medium, large, x-large, xx-large
    @api cardLabelSize; 
    @api isCustomHeader = false;
    @api minHeight;

    _iconConfig;

    @api iconCl;
    
    @api isFooter = false;
    @api isNested = false;
    @api isTable = false;
    @api hasActionSlot = false;

    @api suppressCardPadding = false;
    
    @api 
    set isTileCard(val) {
        this._isTileCard = val;
        this.handleTileCard();
    }
    get isTileCard() {
        return this._isTileCard || false;
    }

    @api addBoxShadowInset = false;
    @api addBoxShadow = false;
    _headerLink;

    @api 
    set recordId(value) {
        this._recordId = value
    } 
    get recordId() {
        return this._recordId;
    }

    @api
    set objectApiName(val) {
        if (val) {
            this._objectApiName = val;
            //this._iconConfig = this.handleIcon(val);
            //this.handleIconSize();
        }
    }
    get objectApiName() {
        return this._objectApiName;
    }

    @api 
    set headerColor(val) {
        this._headerColor = val;
        if (val) {
            this._applyVarsDirect('--c-header-color', val);
        }
    }
    get headerColor() {
        return this._headerColor;
    }

    @api
    set icon(val) {
        this._icon = val;
        this._iconConfig = null;

        if (!val) {
            return;
        }

        const [category, iconName, size] = val.split(':');
        if (!category || !iconName) {
            return;
        }

        this._iconConfig = category === 'material'
            ? materialIconConfig(iconName, size || 'small')
            : sldsIconConfig(category, iconName, size);

        this.handleIconSize();
        this.handleIconColorCl();
    }
    get icon() {
        return this._icon;
    }
    
    @api 
    set iconSize(value) {
        if (value) {
            this._iconSize = value === 'medium' ? ''
                : `slds-icon_${value}`;
            
            this.handleIconSize();
        } else {
            this._iconSize = null; 
        }
    } 
    get iconSize() {
        return this._iconSize === '' ? '' 
            : this._iconSize?.includes('slds') ? this._iconSize
            : null;
    }


    @api iconLabel;
    

    // Card style properties 
    @api cardBg;
    @api cardBorder;
    @api cardHeaderBorderStyle;
    @api cardFooterBg;
    @api suppressHeaderMargin = false;

    @api 
    set suppressFooterBorder(val) {
        this._suppressFooterBorder = val;
        if (val) {
            this._applyVarsDirect('--c-footer-border', val);
        }
    }
    get suppressFooterBorder() {
        return this._suppressFooterBorder;
    }

    @api 
    set footerBorder(val) {
        this._footerBorder = val;
        this._applyVarsDirect('--c-footer-border', val);
    }
    get footerBorder() {
        return this._footerBorder;
    }

    @api 
    set suppressCardShadow(val) {
        this._suppressCardShadow = val;
        if (val) {
            this._applyVarsDirect('--card-shadow', 'none');
        }
    }
    get suppressCardShadow() {
        return this._suppressCardShadow;
    }


    @api 
    set borderRadius(val) {
        this._borderRadius = val;
        if (val) {
            this._applyVarsDirect('--c-border-radius', val);
            if (val === 'var(--slds-g-radius-border-4, 1.25rem)') {
                this._applyVarsDirect('--c-border-complementary', 'none');
            } else if (val === 'var(--slds-g-radius-border-3, 0.75rem)' ) {
                this._applyVarsDirect('--c-border-complementary', 'none');
            }
        }
    }
    get borderRadius() {
        return this._borderRadius;
    }


    @api 
    set cardHeaderBg(value) {
        this._cardHeaderBg = value;
        if (value) {
            this._applyVarsDirect('--c-card-header-bg', value);
        }
    } 
    get cardHeaderBg() {
        return this._cardHeaderBg;
    }

    @api 
    set iconColorCl(value) {
        this._iconColorCl = value;
        this.handleIconColorCl();

    } 
    get iconColorCl() {
        return this._iconColorCl;
    }

    @api 
    set cardHeaderPadding(value) {
        this._cardHeaderPadding = value;
        if (value) {
            this._applyVarsDirect('--c-card-header-padding', value);
        }
    } 
    get cardHeaderPadding() {
        return this._cardHeaderPadding;
    }

    handleIconColorCl() {
        if (
            this.iconColorCl && 
            this._iconConfig?.svg && 
            !this._iconConfig?.svg?.includes(this.iconColorCl)
        ) {
            this._iconConfig = {
                ...this._iconConfig, 
                svg: `${this._iconConfig.svg} ${this.iconColorCl}`
            };
        }
    }

    // Handle "Icon Size" public property
    handleIconSize() {
        if (!this._iconConfig?.svg || 
            this.iconSize === null ||
            this.iconSize === undefined
        ) {
            return;
        }
        const toReplace = this._iconConfig.svg.includes('slds-icon_small')
            ? 'slds-icon_small'
            : 'slds-icon_xx-small';

        this._iconConfig = {
            ...this._iconConfig,
            svg: this._iconConfig.svg.replace(toReplace, this.iconSize)
        }
        this.handleIconColorCl();
    }
    // Get the SOjbect Icon
    handleIcon() {
        try {
            
        } catch(error) {
            console.error('Error in handleIcon() of sldsCard.js: ', error);
        }
    }
    handleRecordIdLink() {
        if (!this.objectApiName || !this.recordId) return;
    }

    renderedCallback() {
        this._applyVars();
    }

    get cardClasses() {
        return `slds-card ${this.isNested ? 'slds-card_boundary' : ''}`;
    }

    // Call this function in renderedCallback  --> e.g. renderedCallback() {this.applyVars();}
    _stylesApplied = false;
    // Apply Styles to the host
    _applyVars() {
        if (this._stylesApplied) return;
        const el = this.template.host; // or a wrapper: this.template.querySelector('.root')

        if (this.cardLabelSize) {
            const cardCl = CARD_LABEL_SIZES[this.cardLabelSize];
            if (cardCl) {
                const cardLabel = this.template.querySelector('.slds-card__header-title')
                if (cardLabel) {
                    cardLabel.classList.replace('slds-card__header-title', cardCl)
                }
            }
        }

        if (this.addBoxShadowInset) {
            const sldsCard = this.template.querySelector('.slds-card');
            if (sldsCard) {
                this._applyVarsDirect('--card-shadow', 'none');
                sldsCard.classList.add('inset-card');
            }
        }

        if (this.suppressCardPadding) {
            const cardBody = this.template.querySelector('.slds-card__body');
            if (cardBody) {
                cardBody.style.margin = '0px';
                cardBody.style.padding = '0px';
            }
        }
        if (this.suppressHeaderMargin) {
            const header = this.template.querySelector('[data-id="card-header"]');
            if (header) {
                header.style.marginBottom = '0px';
            }
        }

        this.handleTileCard();

        if (this.iconCl) {
            const iconContainer = this.template.querySelector('[data-id="iconContainer"]');
            if (iconContainer) iconContainer.classList.add(this.iconCl); 
        }

        if (this.isTable) {
            const cardBody = this.template.querySelector('.slds-card__body');
            if (cardBody) {
                cardBody.style.paddingLeft = '0px';
                cardBody.style.paddingRight = '0px';
            }
        }
        if (this.cardBorder) {
            el.style.setProperty('--card-border', this.cardBorder);
        }

        if (this.cardBg) el.style.setProperty('--slds-c-card-color-background', this.cardBg);
        if (this.cardHeaderBorderStyle) {
            el.style.setProperty('--c-card-header-border-style', this.cardHeaderBorderStyle);
            if (!this.cardHeaderPadding) {
                this._applyVarsDirect('--c-card-header-padding', '0.5rem');
            }
        }
        if (this.isFooter && this.cardFooterBg) {
            el.style.setProperty('--c-card-footer-bg', this.cardFooterBg);
        }
        if (this.minHeight) el.style.setProperty('--min-height', this.minHeight);

        if (this.addBoxShadow && !this.suppressCardShadow) {
            el.style.setProperty('--card-shadow', '0 2px 2px 0 rgba(0, 0, 0, 0.10)');
        }

        this._stylesApplied = true;
    }

    // Apply Styles to the host 👉 Can pass 1.Array of Arrays   2.Array of Object   3.Strings
    _applyVarsDirect(cssVar, varStyle=null) {

        // Check that CSS var starts with '--' and has a non-null stlye 
        const isValid = (cssVarP, varStyleP) => {
            return typeof cssVarP === 'string' && 
                typeof varStyleP === 'string' &&
                cssVarP?.startsWith('--') && 
                varStyleP;
        }

        // Get Host elements
        const el = this.template.host; 

        if (Array.isArray(cssVar)) {
            // Handle Array of vars
            cssVar.forEach(hostVar => {
                if (Array.isArray(hostVar) && isValid(hostVar[0], hostVar[1])) {
                    // Handle Array structure  (CSS var at index 0)
                    el.style.setProperty(hostVar[0], hostVar[1]);
                } else if (typeof hostVar === 'object' && isValid(hostVar.cssVar, hostVar.varStyle)) {
                    // Handle Object structure (cssVar & varStyle keys)
                    el.style.setProperty(hostVar.cssVar, hostVar.varStyle)
                }
            });
        } else if (isValid(cssVar, varStyle)) {
            // Handle string arguments
            el.style.setProperty(cssVar,  varStyle);
        }
    }

    handleTileCard() {
        const cardHeader = this.template.querySelector('[data-id="card-header"]');
        if (cardHeader) {
            if (this.isTileCard) {
                // Remove tile-margin from the card
                cardHeader.classList.replace('slds-card__header', 'slds-card-flex-height__header');

            } else if (cardHeader.classList.contains('slds-card-flex-height__header')) {
                // Restore card-margin if not tile
                cardHeader.classList.replace('slds-card-flex-height__header', 'slds-card__header')
            }
        }
    
    }

    toastObj;
    showToast(title, message, variant, mode=null) {
        const modeP = mode 
            ? mode 
                : variant === 'success'
            ? 'dismissible'
            : 'sticky';
        
        this.toastObj = { 
            variant: variant, 
            mode: modeP, 
            message: message,
            header: { 
                text: title
            }        
        };
    }
}
